import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { setEndpointHost, setEndpointPath, setHeaders } from '@keypr/redux-json-api';
import { browserHistory } from 'react-router';
import refresh from './state/middleware/refresh';
import apiError from './state/middleware/apiError';
import rootReducer from './state/reducers';
import api from './utils/api';
import settings from './config/settings';

const twa = thunk.withExtraArgument(api);

const router = routerMiddleware(browserHistory);

const loggerMiddleware = settings.debug ? [createLogger()] : [];
const middleware = [twa, apiError, refresh, router, ...loggerMiddleware];

const store = createStore(rootReducer, applyMiddleware(...middleware));

store.dispatch(setEndpointHost(settings.gems_url));
store.dispatch(setEndpointPath(settings.api_path));
store.dispatch(setHeaders({
  'Content-Type': 'application/vnd.api+json',
}));

export const history = syncHistoryWithStore(browserHistory, store);
export default store;



// WEBPACK FOOTER //
// ./src/store.js